import React, { Component } from "react";
import {
  Card,
  CardBody,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input,
  ButtonGroup,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Badge,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import {
  getPIReqList,
  SetParams,
  modelListOpen,
  modelListClose,
  listlayout,
  // getMaterialRequests,
  // toggleItemMenu,
  // materialRequestDelete,
} from "../../../store/PurchaseIndent/actions";
import moment from "moment";
import swal from "sweetalert";
import { AvForm } from "availity-reactstrap-validation";
import Defaultuser from "../../../assets/images/users/Default_User.png";
import LoadingModel from "../../LoadingModel";

class AllPurchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      duedate: "",

      pageCount: 1,
      offset: 0,
      data: [],
      perPage: 5,
      currentPage: 0,
      rowlist: [],
      currentSort: "default",
    };

    // this.deleteRecord = this.deleteRecord.bind(this);
    // this.handlePageClick = this.handlePageClick.bind(this);
  }

  onSortChange = () => {
    var sort = ["code", "createdon"];
    var currentSort = this.props.params.currentSort;
    var i = sort.indexOf(currentSort);
    if (i !== -1 && i + 1 < sort.length) {
      currentSort = sort[i + 1];
    } else {
      currentSort = sort[0];
    }
    this.props.SetParams({ ...this.props.params, currentSort: currentSort });
    this.props.getPIReqList({
      ...this.props.params,
      currentSort: currentSort,
    });
  };
  onSortOrderChange = () => {
    var sortOrder = this.props.params.sortOrder;
    if (sortOrder === "") {
      sortOrder = "-";
    } else {
      sortOrder = "";
    }

    this.props.SetParams({ ...this.props.params, sortOrder: sortOrder });
    this.props.getPIReqList({
      ...this.props.params,
      sortOrder: sortOrder,
    });
  };
  onlayoutChange = () => {
    var layout = this.props.layout;
    if (layout === "list") {
      layout = "table";
    } else {
      layout = "list";
    }
    this.props.listlayout(layout);
  };
  autohandleSearch = (e) => {
    this.props.SetParams({
      ...this.props.params,
      search: e.target.value,
      page: 1,
    });
    if (e.target.value === "") {
      this.props.getPIReqList(
        {
          ...this.props.params,
          search: "",
          page: 1,
        },
        true
      );
    }
  };
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.getPIReqList({
        ...this.props.params,
        page: 1,
        search: e.target.value,
      });
    }
  };
  deleteRecord = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.props.materialRequestDelete(id, this.props.history);
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };
  openPage(pageNo) {
    this.props.SetParams({ ...this.props.params, page: pageNo });
    this.props.getPIReqList({ ...this.props.params, page: pageNo });
  }
  //>>>>>>>>>>>>>>>>>>>>>>>>

  render() {
    return (
      <React.Fragment>
         {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

        <div className="mt-2 ">
          <div>
            <Row>
              <Col md={3}>
                <AvForm className="p-1">
                  <FormGroup className="m-0">
                    <InputGroup>
                      <Input
                        type="text"
                        name="search"
                        className="form-control d-inline-block"
                        placeholder="Search"
                        validate={{ required: true }}
                        onChange={(e) => this.autohandleSearch(e)}
                        onKeyDown={(e) => this.handleSearch(e)}
                      />
                      <InputGroupAddon addonType="append">
                        <Button
                          color="light"
                          type="submit"
                          onClick={() =>
                            this.props.getPIReqList({
                              ...this.props.params,
                              page: 1,
                            })
                          }
                        >
                          <i className="ri-search-line"></i>
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </AvForm>
              </Col>
              <Col md={9}>
                <div className="float-right p-1">
                  <div className="d-inline-block">
                    <Pagination aria-label="Page navigation example">
                      <PaginationItem disabled={this.props.params.page <= 1}>
                        <PaginationLink
                          onClick={(e) => this.openPage(1)}
                          previous
                          // href="#"
                        />
                      </PaginationItem>

                      {this.props.params.page > 2 && (
                        <PaginationItem disabled={this.props.params.page <= 2}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page > 1 && (
                        <PaginationItem disabled={this.props.params.page === 1}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}

                      <PaginationItem active={true}>
                        <PaginationLink
                          onClick={() => this.openPage(this.props.params.page)}
                          // href="#"
                        >
                          {this.props.params.page}
                        </PaginationLink>
                      </PaginationItem>
                      {this.props.params.page + 1 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 1 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 2 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 2 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 3 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 3 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 3 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 3)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 3}
                            </PaginationLink>
                          </PaginationItem>
                        )}
                      {this.props.params.page + 4 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 2 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 4 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 4)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 4}
                            </PaginationLink>
                          </PaginationItem>
                        )}

                      <PaginationItem
                        disabled={
                          this.props.params.no_of_pages ===
                          this.props.params.page
                        }
                      >
                        <PaginationLink
                          onClick={(e) =>
                            this.openPage(this.props.params.no_of_pages)
                          }
                          next
                          // href="#"
                        />
                      </PaginationItem>
                    </Pagination>
                  </div>
                  <ButtonGroup className="waves-effect waves-light d-inline-block ml-2 mr-2">
                    <Button color="light" onClick={this.onSortOrderChange}>
                      {this.props.params.sortOrder === "" && (
                        <i className="mdi mdi-sort-ascending mr-1"></i>
                      )}
                      {this.props.params.sortOrder === "-" && (
                        <i className="mdi mdi-sort-descending mr-1"></i>
                      )}
                    </Button>
                    <Button color="light" onClick={this.onSortChange}>
                      {this.props.Sortvar[this.props.params.currentSort]}
                    </Button>
                  </ButtonGroup>
                  <Button color="light" onClick={this.onlayoutChange}>
                    {this.props.layout === "list" && (
                      <i className="mdi mdi-table-large"></i>
                    )}
                    {this.props.layout === "table" && (
                      <i className="mdi mdi-format-list-bulleted"></i>
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ maxHeight: "100%" }}>
            <Card className="p-0">
              <CardBody className="p-2">
                {this.props.layout === "list" && (
                  <>
                    {this.props.PIRowListCount !== 0 ? (
                      <>
                        {this.props.PIRowList?.map((PIItem) => (
                          <div className="bg_color p-2 mb-1" key={PIItem.id}>
                            <Row className="justify-content-center">
                              <Col md={2}>
                                <div className="Material_detiles p-2">
                                  <Link to={`pirequest1/${PIItem.id}`}>
                                    <Button
                                      type="button"
                                      color={
                                        PIItem.pistatus === 1 ||
                                        PIItem.pistatus === 2
                                          ? "primary"
                                          : PIItem.pistatus === 3
                                          ? "success"
                                          : "danger"
                                      }
                                      className="waves-effect waves-light orderlist_but p-1 mb-2"
                                    >
                                      <i className="mdi mdi-file-document mr-1"></i>
                                      {PIItem.code}
                                    </Button>
                                  </Link>
                                  <p className="items_title m-1">
                                    List Items:{" "}
                                    <span className="item_title_Detiles">
                                      {PIItem.items_count}
                                    </span>
                                  </p>
                                  <Link
                                    to="#"
                                    className="m-0"
                                    onClick={() =>
                                      this.props.modelListOpen(PIItem.id)
                                    }
                                  >
                                    <i className="mdi mdi-plus"></i>
                                    More Details
                                  </Link>
                                </div>
                              </Col>
                              <Col md={10}>
                                <Row className="p-0">
                                  <Col md={8} className="p-0">
                                    <div className="Material-panel-content">
                                      <div className="list-column">
                                        <ul className="list-style-seven p-0">
                                          <li className="clearfix">
                                            <span className="ttl">
                                              Department:
                                            </span>
                                            <span className="dtl">
                                              {PIItem.department?.name}
                                            </span>
                                          </li>
                                          <li className="clearfix">
                                            <span className="ttl">
                                              Submited:
                                            </span>
                                            <span className="dtl">
                                              {moment(PIItem.createdon).format(
                                                "DD-MM-YYYY"
                                              )}
                                            </span>
                                          </li>
                                          <li className="clearfix">
                                            <span className="ttl">
                                              Location:
                                            </span>
                                            <span className="dtl">
                                              {PIItem?.location?.name}
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md={4}>
                                    <div className="float-right">
                                      <div className="user-content-box">
                                        <ul className="list-style-seven mb-1">
                                          <li className="clearfix">
                                            <span className="ttl">
                                              {PIItem.pistatus_name}
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                      <ul className="user-column p-0">
                                        <li className="clearfix p-0 m-0">
                                          <span className="img">
                                            <img
                                              className="img-fluid p-0"
                                              src={
                                                PIItem.createdby?.image == null
                                                  ? Defaultuser
                                                  : PIItem.createdby?.image
                                              }
                                              // src={
                                              //   Material.requestapproved[0]
                                              //     ? Material.requestapproved[0]
                                              //       .approvedby.userprofile.avatar
                                              //     : ""
                                              // }
                                              alt="user"
                                            />
                                          </span>
                                          <span className="ttl">
                                            {PIItem.createdby?.fullname}
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div className="text-center">
                        <span className="font-size-24 text-danger">
                          Data not available{" "}
                        </span>
                      </div>
                    )}
                  </>
                )}
                {this.props.layout === "table" && (
                  <CardBody className="p-2 ">
                    <div className="table-responsive m-0">
                      <Table bordered hover className="mb-0 p-0 table-centered">
                        <thead className="bg-light text-center">
                          <tr>
                            <th className="nowrap">PI Code</th>
                            <th className="nowrap">No.of Items</th>

                            <th className="nowrap">Department</th>
                            <th className="nowrap">Submited</th>
                            <th className="nowrap">Status</th>
                          </tr>
                        </thead>
                        <tbody className="nowrap">
                          {this.props.PIRowListCount !== 0 ? (
                            <>
                              {this.props.PIRowList?.map((PIItem, key) => (
                                <tr key={key} className="text-center">
                                  <td>
                                    <Link to={`pirequest1/${PIItem.id}`}>
                                      <Button
                                        type="button"
                                        color={
                                          PIItem.pistatus === 1 ||
                                          PIItem.pistatus === 2
                                            ? "primary"
                                            : PIItem.pistatus === 3
                                            ? "success"
                                            : "danger"
                                        }
                                        className="waves-effect waves-light orderlist_but p-1"
                                      >
                                        <i className="mdi mdi-file-document mr-1"></i>
                                        {PIItem.code}
                                      </Button>
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to="#"
                                      className="m-0"
                                      onClick={() =>
                                        this.props.modelListOpen(PIItem.id)
                                      }
                                    >
                                      {PIItem.items_count} Items
                                    </Link>
                                  </td>

                                  <td>{PIItem.department?.name}</td>
                                  <td>
                                    {moment(PIItem.createdon).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </td>
                                  <td>
                                    <Badge
                                      className="font-size-14"
                                      color={
                                        PIItem.pistatus === 1 ||
                                        PIItem.pistatus === 2
                                          ? "primary"
                                          : PIItem.pistatus === 3
                                          ? "success"
                                          : "danger"
                                      }
                                    >
                                      {PIItem.pistatus_name}
                                    </Badge>
                                  </td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colspan="7" className="text-center">
                                <span className="font-size-18 text-danger">
                                  Data not available
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                )}
              </CardBody>
            </Card>
          </SimpleBar>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { PIRowList, PIRowListCount, params, Sortvar, layout, loading } =
    state.PurchaseIndent;

  return { PIRowList, PIRowListCount, params, Sortvar, layout, loading };
};

export default connect(mapStatetoProps, {
  getPIReqList,
  SetParams,
  modelListOpen,
  modelListClose,
  listlayout,
  //--------
  // toggleItemMenu,
  // getMaterialRequests,

  // materialRequestDelete,
})(AllPurchase);
